import { getKeycloak } from './keycloak-instance';

/**
 * Logs the recruiter out and returns them to the login screen.
 *
 * Routes through Keycloak's end-session endpoint — `keycloak-js` builds the
 * `…/protocol/openid-connect/logout?post_logout_redirect_uri=…` URL and sets
 * `window.location` — so this clears the server-side `KEYCLOAK_SESSION` /
 * `KEYCLOAK_IDENTITY` cookies AND drops the in-memory access token. Merely
 * wiping local state would NOT log the user out of Keycloak: the next
 * `check-sso` would silently re-authenticate from the still-valid SSO session.
 *
 * This is the single source of truth for "log out" in the recruiter SPA and the
 * default action behind the ConsultantsMenu "Sair" button.
 */
export function logoutToLogin(): void {
  getKeycloak().logout({ redirectUri: `${window.location.origin}/login` });
}
